<dx-load-indicator [height]="$size()" [width]="$size()"></dx-load-indicator>
